<template> 
     <router-view></router-view>
</template> 
<script>
    export default {
        name:'home',
        data () {
            return {  
            }
        },
       
        computed: {
          
            
        },
        methods: {
               
           
            
        },
      
        mounted: function(){
            var that = this;
          
        }
    }
</script>  
<style>
    
</style>
     